// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Landload pages */
.drop-down-min {
  min-width: 101px !important;
  height: 0px;
}

.property_detail_heading {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -5px;
  margin-left: -5px;
}

.landload_property_details {
  display: flex;
  justify-content: space-between;
}

.addproperty_form .form-control {
  border-radius: 12px;
  border: 1px solid #e9ecef !important;
  background: var(--White, #fff);
  height: 50px !important;
  color: var(--Black, #010404);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.agent_add_block h6 {
  font-size: 16px;
  font-weight: 700;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: left;
}

a.btn_agent_landload {
  font-size: 16px;
  font-weight: 700;
  line-height: 19px;
  letter-spacing: 0px;
  text-align: left;
  color: #2176ff;
  background: none;
}

.btn-delete-details {
  min-width: 160px;
  height: 50px;
  background: #fd0d0d1a;
  font-size: 18px;
  font-weight: 700;
  line-height: 22px;
  letter-spacing: 0em;
  color: #fd0d0d;
  border-radius: 12px;
  border: none;
}

.btn-save-details {
  font-size: 18px;
  font-weight: 700;
  line-height: 22px;
  letter-spacing: 0em;
  color: #ffffff;
  min-width: 160px;
  height: 50px;
  border-radius: 12px;
  border: none;
  background: #163873;
}

.btn-boots-details {
  background: #163873;
  min-width: 97px;
  height: 40px;
  border-radius: 8px;
  font-size: 16px;
  color: #ffffff;
  border: none;
  font-weight: 700;
  line-height: 19px;
  letter-spacing: 0em;
}

.select-text {
  font-size: 12px !important;
  line-height: 14.4px;
  font-weight: 500 !important;
}

.dropdown__menu__item {
  box-shadow: 0px 8px 18px 0px #0000001a !important;
  border: none !important;
  border-radius: 10px !important;
  min-width: 180px !important;
}

.text-add-text {
  font-size: 24px;
  font-weight: 700;
  line-height: 29px;
  letter-spacing: 0em;
}

.create_btn {
  min-width: 170px;
  height: 50px;
  border-radius: 12px;
  font-size: 18px;
  font-weight: 700;
  line-height: 22px;
  letter-spacing: 0em;
  border: none;
  background: #163873;
  color: #fff;
}

.h6_span_text {
  font-size: 16px;
  font-weight: 500;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: left;
  color: #010404;
}

.plus_icon {
  width: 48px;
  height: 48px;
}

.pending-btn-active {
  font-size: 12px;
}

.img_width {
  min-width: 26px !important;
  max-height: 26px !important;
}

.text-red {
  color: #fd0d0d !important;
}

span.date_icon {
  position: absolute;
  right: 30px;
  top: 38px;
  transform: translate(0px, 0px);
}
`, "",{"version":3,"sources":["webpack://./src/components/landloadownerpenal/styles/landload-common.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EAEb,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,8BAA8B;EAC9B,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,iDAAiD;EACjD,uBAAuB;EACvB,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,8BAA8B;AAChC","sourcesContent":["/* Landload pages */\n.drop-down-min {\n  min-width: 101px !important;\n  height: 0px;\n}\n\n.property_detail_heading {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.form-row {\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  margin-right: -5px;\n  margin-left: -5px;\n}\n\n.landload_property_details {\n  display: flex;\n  justify-content: space-between;\n}\n\n.addproperty_form .form-control {\n  border-radius: 12px;\n  border: 1px solid #e9ecef !important;\n  background: var(--White, #fff);\n  height: 50px !important;\n  color: var(--Black, #010404);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.agent_add_block h6 {\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 19px;\n  letter-spacing: 0em;\n  text-align: left;\n}\n\na.btn_agent_landload {\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 19px;\n  letter-spacing: 0px;\n  text-align: left;\n  color: #2176ff;\n  background: none;\n}\n\n.btn-delete-details {\n  min-width: 160px;\n  height: 50px;\n  background: #fd0d0d1a;\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 22px;\n  letter-spacing: 0em;\n  color: #fd0d0d;\n  border-radius: 12px;\n  border: none;\n}\n\n.btn-save-details {\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 22px;\n  letter-spacing: 0em;\n  color: #ffffff;\n  min-width: 160px;\n  height: 50px;\n  border-radius: 12px;\n  border: none;\n  background: #163873;\n}\n\n.btn-boots-details {\n  background: #163873;\n  min-width: 97px;\n  height: 40px;\n  border-radius: 8px;\n  font-size: 16px;\n  color: #ffffff;\n  border: none;\n  font-weight: 700;\n  line-height: 19px;\n  letter-spacing: 0em;\n}\n\n.select-text {\n  font-size: 12px !important;\n  line-height: 14.4px;\n  font-weight: 500 !important;\n}\n\n.dropdown__menu__item {\n  box-shadow: 0px 8px 18px 0px #0000001a !important;\n  border: none !important;\n  border-radius: 10px !important;\n  min-width: 180px !important;\n}\n\n.text-add-text {\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 29px;\n  letter-spacing: 0em;\n}\n\n.create_btn {\n  min-width: 170px;\n  height: 50px;\n  border-radius: 12px;\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 22px;\n  letter-spacing: 0em;\n  border: none;\n  background: #163873;\n  color: #fff;\n}\n\n.h6_span_text {\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 19px;\n  letter-spacing: 0em;\n  text-align: left;\n  color: #010404;\n}\n\n.plus_icon {\n  width: 48px;\n  height: 48px;\n}\n\n.pending-btn-active {\n  font-size: 12px;\n}\n\n.img_width {\n  min-width: 26px !important;\n  max-height: 26px !important;\n}\n\n.text-red {\n  color: #fd0d0d !important;\n}\n\nspan.date_icon {\n  position: absolute;\n  right: 30px;\n  top: 38px;\n  transform: translate(0px, 0px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
